import React, { useState, useEffect } from 'react';
import styles from './Navbar.module.css';
import logo from '../../images/מורן וינברגר לוגו.webp';

const navLinks = [
  { label: 'שירותי הסטודיו', href: '#שירותים' },
  { label: 'פרויקטים', href: '#פרוייקטים' },
  { label: 'קצת עלי', href: '#מי-אני' },
  { label: 'שאלות תשובות', href: '#שאלות-תשובות' },
];

const whatsappUrl = 'https://wa.me/972502177062?text=' +
  encodeURIComponent('היי מורן, הגעתי מהאתר שלך ואשמח שנדבר על..');

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  };

  return (
    <>
      {/* Hamburger Button */}
      <button
        className={`${styles.hamburger} ${scrolled ? styles.hamburgerScrolled : ''} ${menuOpen ? styles.hamburgerOpen : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="תפריט"
      >
        <span className={styles.line} />
        <span className={styles.line} />
        <span className={styles.line} />
      </button>

      {/* Fullscreen Menu */}
      <div className={`${styles.overlay} ${menuOpen ? styles.overlayOpen : ''}`}>
        <div className={styles.menuContent}>
          {/* Logo */}
          <div className={styles.menuLogo}>
            <img src={logo} alt="מורן הום" className={styles.logoImg} />
          </div>

          {/* Nav Links */}
          <nav className={styles.nav}>
            {navLinks.map((link, i) => (
              <a
                key={i}
                href={link.href}
                className={styles.navLink}
                onClick={(e) => handleNavClick(e, link.href)}
                style={{ transitionDelay: menuOpen ? `${0.15 + i * 0.07}s` : '0s' }}
              >
                {link.label}
              </a>
            ))}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.navLink}
              style={{ transitionDelay: menuOpen ? `${0.15 + navLinks.length * 0.07}s` : '0s' }}
            >
              צור קשר
            </a>
          </nav>

          {/* Footer Icons */}
          <div className={styles.menuFooter}>
            <div className={styles.footerIcons}>
              <a
                href="https://www.instagram.com/moranw.home/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerIcon}
                aria-label="Instagram"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="5" />
                  <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
                </svg>
              </a>
              <a href="tel:+972502177062" className={styles.footerIcon} aria-label="טלפון">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                </svg>
              </a>
              <a href="mailto:mazalmoran24@gmail.com" className={styles.footerIcon} aria-label="אימייל">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="M22 7l-10 7L2 7" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
